import React from 'react';
import { Button } from '../Button';
import { CTAProps } from './CTA.types';

export const CTA = ({
  headingText,
  leadText,
  buttons,
}: CTAProps): JSX.Element => {
  return (
    <div className='cta color-background'>
      {/* Heading Text */}
      {headingText && (
        <span className='cta_heading text-heading_4'>{headingText}</span>
      )}

      {/* Lead Text */}
      {leadText && <span className='cta_lead text_3'>{leadText}</span>}

      {/* Buttons | CTA's */}
      {buttons && (
        <div className='cta_button-group button-group'>
          {buttons.map((button, index) => {
            return (
              <div key={index} className='button-group__item'>
                <Button {...button} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
